import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { TipCard } from 'src/modules/programs/components/TipCard';
import * as S from 'src/modules/programs/stepComponents/styles';
import nonJudgmentIcon from 'src/public/img/illustration-smiley-face.svg';
import awarnessIcon from 'src/public/img/undraw-feeling-blue-4-b-7-q-copy.svg';

const emotionsIcons = [awarnessIcon, nonJudgmentIcon];

interface MindfulEmotion {
    title: string;
    description: string;
    icon: string;
}

export const WhatIsMindfulnessOfEmotionsStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const emotionsCards: MindfulEmotion[] = t(
        'week-4.what-is-mindfulness-of-emotions.emotionsCards',
        {
            returnObjects: true,
        },
    );

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading>
                        {t('week-4.what-is-mindfulness-of-emotions.title')}
                    </S.StepHeading>
                    <S.StepDescription small>
                        {t('week-4.what-is-mindfulness-of-emotions.description')}
                    </S.StepDescription>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow type="flex">
                {emotionsCards.map((emotion, index: number) => (
                    <TipCard
                        iswide
                        key={emotion.title}
                        iconUrl={emotionsIcons[index]}
                        title={emotion.title}
                        children={emotion.description}
                    />
                ))}
            </S.ContentRow>
        </>
    );
});
